import { useNavigate } from "react-router-dom";
import CustomButton from "../../components/CustomButton";
import PageHeader from "../../components/PageHeader";
import PaginationBar from "../../components/PaginationBar";
import FormList from "./FormList";

export default function Form() {
  const navigate = useNavigate()

  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-row justify-between items-start  gap-5">
        <PageHeader />
        <div className="flex flex-wrap gap-3 justify-end items-end ">
          <CustomButton
            text="Create Form"
            color="bg-primary-500"
            onClick={() => navigate("/form/create-form")}
          />
        </div>
      </div>
      <FormList />
    </div>
  );
}
